import { CANDID_TITLE, STEDI_TITLE } from "@tellescope/constants";
import type { FormFieldOptions } from "@tellescope/types-models";

/** The form field types backed by a real-time eligibility check against an external vendor. */
export type EligibilityFieldType = "Candid Eligibility" | "Stedi Eligibility";

/**
 * Everything that differs between the eligibility vendors.
 *
 * The vendors are otherwise identical on the client — same inputs, same UI states, same answer
 * shape — so this descriptor is what a vendor-specific field passes into the shared hook and
 * components instead of duplicating them.
 */
export interface EligibilityVendor {
  /** Integration title the proxy routes on. */
  integration: string;
  /** `proxy_read` request type for this vendor's eligibility check. */
  proxyType: string;
  /** X12 service type code configured on the field, which each vendor stores under its own key. */
  serviceCodeOf: (options?: FormFieldOptions) => string | undefined;
  /** Rendering provider NPI configured on the field. */
  npiOf: (options?: FormFieldOptions) => string | undefined;
}

export const CANDID_ELIGIBILITY_VENDOR: EligibilityVendor = {
  integration: CANDID_TITLE,
  proxyType: "candid-eligibility",
  serviceCodeOf: (options) => options?.candidServiceCode,
  npiOf: (options) => options?.candidNPI,
};

export const STEDI_ELIGIBILITY_VENDOR: EligibilityVendor = {
  integration: STEDI_TITLE,
  proxyType: "stedi-eligibility",
  serviceCodeOf: (options) => options?.stediServiceCode,
  npiOf: (options) => options?.stediNPI,
};
